// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Parent container for the messages */
.recent-message-log {
	list-style: none;
	margin: 0;
	padding: 0 1rem;
	width: 100%;
	max-height: 100vh;
	overflow-y: auto;
}

/* Scrollbar style for the list of messages -- START -- */
.recent-message-log::-webkit-scrollbar {
	width: 10px;
}

.recent-message-log::-webkit-scrollbar-track {
	background: rgb(233, 232, 232);
	border-radius: 20px;
}

.recent-message-log::-webkit-scrollbar-thumb {
	background: rgba(198, 197, 197, 0.8);
	border-radius: 20px;
}

.recent-message-log::-webkit-scrollbar-thumb:hover {
	background: rgb(198, 197, 197);
}
/* Scrollbar style for the list of messages -- END -- */

/* Each message list item -- START -- */
.recent-message-log li {
	cursor: pointer;
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0.5rem 0;
	margin-top: 1rem;
	position: relative;
}

.recent-message-log li:hover {
	background: rgb(242, 242, 242);
	border-radius: 15px;
}

.recent-message-log li:not(:last-child)::after {
	display: block;
	position: absolute;
	content: "";
	border-bottom: 2px solid #b8b8b8;
	width: 94%;
	left: 6%;
	margin: auto;
	bottom: -4px;
}

.recent-message-log li:nth-child(n + 2) {
	margin-top: 1rem;
}

/* Icon style -- START -- */
.recent-message-log-icon span {
	height: 3.25rem;
	width: 3.25rem;
	background-color: rgb(222, 222, 222);
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 1rem;
	margin-left: 0.5rem;
}

.recent-message-log-icon i {
	font-size: 1.5rem;
}
/* Icon style -- END -- */

/* Everything aside from the icon in each list -- START -- */
.recent-message-log-content {
	display: flex;
	flex-grow: 2;
}

.recent-message-log-content div:first-child {
	width: 70%;
}

.recent-message-log-content div:first-child :first-child {
	font-size: 1.125em;
	margin-bottom: 0.25rem;
}

.recent-message-log-content div:nth-child(2) {
	width: 30%;
	display: flex;
	justify-content: flex-end;
	margin-right: 0.5rem;
}

.recent-message-log li div p {
	margin: 0;
}
/* Everything aside from the icon in each list -- END -- */
/* Each message list item -- END -- */
`, "",{"version":3,"sources":["webpack://./src/assets/css/recent-message-log.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;CACC,gBAAgB;CAChB,SAAS;CACT,eAAe;CACf,WAAW;CACX,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA,yDAAyD;AACzD;CACC,WAAW;AACZ;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;CACpC,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;AAC/B;AACA,uDAAuD;;AAEvD,uCAAuC;AACvC;CACC,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,gCAAgC;CAChC,UAAU;CACV,QAAQ;CACR,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA,2BAA2B;AAC3B;CACC,eAAe;CACf,cAAc;CACd,oCAAoC;CACpC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;AACA,yBAAyB;;AAEzB,4DAA4D;AAC5D;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,aAAa;CACb,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,SAAS;AACV;AACA,0DAA0D;AAC1D,qCAAqC","sourcesContent":["/* Parent container for the messages */\n.recent-message-log {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0 1rem;\n\twidth: 100%;\n\tmax-height: 100vh;\n\toverflow-y: auto;\n}\n\n/* Scrollbar style for the list of messages -- START -- */\n.recent-message-log::-webkit-scrollbar {\n\twidth: 10px;\n}\n\n.recent-message-log::-webkit-scrollbar-track {\n\tbackground: rgb(233, 232, 232);\n\tborder-radius: 20px;\n}\n\n.recent-message-log::-webkit-scrollbar-thumb {\n\tbackground: rgba(198, 197, 197, 0.8);\n\tborder-radius: 20px;\n}\n\n.recent-message-log::-webkit-scrollbar-thumb:hover {\n\tbackground: rgb(198, 197, 197);\n}\n/* Scrollbar style for the list of messages -- END -- */\n\n/* Each message list item -- START -- */\n.recent-message-log li {\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 0.5rem 0;\n\tmargin-top: 1rem;\n\tposition: relative;\n}\n\n.recent-message-log li:hover {\n\tbackground: rgb(242, 242, 242);\n\tborder-radius: 15px;\n}\n\n.recent-message-log li:not(:last-child)::after {\n\tdisplay: block;\n\tposition: absolute;\n\tcontent: \"\";\n\tborder-bottom: 2px solid #b8b8b8;\n\twidth: 94%;\n\tleft: 6%;\n\tmargin: auto;\n\tbottom: -4px;\n}\n\n.recent-message-log li:nth-child(n + 2) {\n\tmargin-top: 1rem;\n}\n\n/* Icon style -- START -- */\n.recent-message-log-icon span {\n\theight: 3.25rem;\n\twidth: 3.25rem;\n\tbackground-color: rgb(222, 222, 222);\n\tborder-radius: 50%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-right: 1rem;\n\tmargin-left: 0.5rem;\n}\n\n.recent-message-log-icon i {\n\tfont-size: 1.5rem;\n}\n/* Icon style -- END -- */\n\n/* Everything aside from the icon in each list -- START -- */\n.recent-message-log-content {\n\tdisplay: flex;\n\tflex-grow: 2;\n}\n\n.recent-message-log-content div:first-child {\n\twidth: 70%;\n}\n\n.recent-message-log-content div:first-child :first-child {\n\tfont-size: 1.125em;\n\tmargin-bottom: 0.25rem;\n}\n\n.recent-message-log-content div:nth-child(2) {\n\twidth: 30%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-right: 0.5rem;\n}\n\n.recent-message-log li div p {\n\tmargin: 0;\n}\n/* Everything aside from the icon in each list -- END -- */\n/* Each message list item -- END -- */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
